import React from 'react'
import bgimg from '../assests/bg.jpg';
import slack from '../assests/slack2.png';
import amazon from '../assests/aws2.png'
import wp from '../assests/wp.png';
import google from '../assests/gd2.png';
import intro from '../assests/intro.png';
import dep from '../assests/dep.png';
import insti from '../assests/insti.png';
import hardware from '../assests/hardware.jpg';
import software from '../assests/software.jpg';
import webd from '../assests/webd.jpg'
import job from '../assests/job.png'
import { Link } from 'react-router-dom';

import "./home.css";


function Home() {
  return (
    <div className='Homepage'>

      {/* first section */}
      <div className="section-first">
        <img src={bgimg} alt="hnb img" className="bgimg" />
        <p className="contentfirst">
          IT infrastructure solutions for PC hardware maintenance and networking support.
        </p>

        <div className="buttonsfirst">
        <button id="btnfirst1">Our Services</button>
        <button id="btnfirst2">Get Started</button>
        </div>
      </div>



      {/* second section */}
      <div className="section-second">
        <div className="section-companies">
          <img src={slack} alt="Slack" className="slackimg" /><p className="slack">Slack</p>
          <img src={amazon} alt="amazon" className="amazon" /><p className="aws">Amazon</p>
          <img src={wp} alt="wordpress" className="wp" /><p className="wordpress">Wordpress</p>
          <img src={google} alt="googlecloud" className="google" /><p className="gc">Google Cloud</p>
        </div>
      </div>



      {/* third section */}
      <section className='thirsdsec'>
      <div className="thirstitles">
        <p className="intro">Introduction</p>
        <p className="dep">Departments</p>
        <p className="instit">Institutes</p>
      </div>
      <div className="thirdcontainer">
        <div className="container1">
          <img src={intro} alt="intro" className='introimg' /><p className="intropara">Our institute is One of the leading
            institutes for Computer Studies and
            Cyber Security which works on live
            Setup. We Provides All  Software Training
            , Hardware Training , Network Training
            and Web Designing Training. We also
            Provides Placements To all candidates
            in their respective fields. We also Works
            on live projects as well as provides
            training for Hosting.</p>
        </div>

        <div className="container2">
          <img src={dep} alt="department" className="depimg" /><p className="deppara">We have experienced faculty for every
            subjects. Get admission in our institute today and enhance your knowledge with
            our best faculty. Every department will monitor individual students with proper
            guidance. Learn best technologies from
            us!</p>
        </div>

        <div className="container3">
          <img src={insti} alt="" className="intimg" /><p className="instipara">We have 6 institutes. every institute are
            well managed and regularly monitored by
            our managing team. Choose your best
            place to learn and choose your best
            program from our institute. Your success
            and bright future always be on the right
            institute and right program.</p>
        </div>
      </div>
      </section>

      

      {/* fouth section */}
      <div className="fouth">
        <div className="fourthtitle">
          <p>Explore all plannings</p>
        </div>

        <div className="exploreimg">
          <img src={hardware} alt="hardware" className="hardware" />
          <img src={software} alt="software" className="software" />
          <img src={webd} alt="web development" className='webd'/>
        </div>
      <div className="exploresubtitles">
      <div className="sub1"><p className="hardpara">Hardware & Networking Training</p>
      <button id='btnsub1'><Link target={"_blank"} to="Hardware & Networking Training">Read more</Link></button>
      </div>
      <div className="sub2"><p className="softpara">Software Training</p>
      <button id='btnsub2'><Link target={"_blank"} to="Software Training">Read more</Link></button>
      </div>
      <div className="sub3"><p className="webdpara">Web Design & Development Training</p>
      <button id='btnsub3'><Link target={"_blank"} to="Web Design & Development Training">Read more</Link></button>
      </div>
      </div>


      </div>
      


      {/* fifth section */}
      <div className="fifth">
        <div className="fiftetitle">Job Oriented Programming Language Training In Ahmedabad By Industry Experts</div>
        <div className="fifthcontainer">
          <p className="para1">H & B Computer Education offers the best programming language training in Ahmedabad with most experienced industry experts. Our experts know the industry requirements and the training sessions we provide are handy for job aspirants to get ample practical exposure. Every session of our software training in Ahmedabad is based on the slogan ‘get trained and get employed. Therefore, all our training courses are in line with the job requirements demanded by all the leading industries.</p>
          <p className="para2">We are the best providers of graphics designing training in Ahmedabad with advanced labs. The trainers working in our institute of language training in Ahmedabad are permanent employees who have proved their mettle in leading MNCs for many years. Hence, our candidates of software training in Ahmedabad receive loads of practical knowledge that would provide them with the calibre to perform in the real-time scenarios of their future endeavours. The topics of our hardware and networking training in Ahmedabad include the latest and the real-time examples to make our candidates highly competent in any industry.</p>
        </div>
      </div>



      {/* sixth section */}
      <section className="sixsec">
        <div className="sixcontainer">
          <img src={job} alt="job" className="job" />
          <p className="parasix">
          H & B Computer Education is one of the leading IT training companies across the country. We believe in nothing less than excellence and we want to instill the same ideology in our students as well. we have managed to produce more than 650 raw talents in various sector  like Hardware , Networking, Cyber security & Ethical Hacking, PHP, Asp.Net, Android, front end Development SEO, Testing etc. Out of that, more than 610 students have been placed at reputed organizations around the country and rest of students have been associated with H & B InfoTech, which is our company.
          </p>
        </div>
      </section>



      {/* seventh section */}
      <section className="seventh">
        <div className="containerseven">
          <p className="sevenpara">Feeling comfortable and feel free to get in touch</p>
          <input type="text" placeholder='Enter your email' />
        </div>
        <button>Send</button>
      </section>



      {/* eight section */}




      
    </div>
  )
}

export default Home